import { render } from "./Monitor.vue?vue&type=template&id=d044d912"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
script.render = render

export default script